import { Layout } from '@components/sales';
import { Checkout as SaleCheckout } from '@components/sales';

const Checkout = () => {
    return <SaleCheckout />;
};

Checkout.Layout = Layout;
export default Checkout;
